import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import Overlay from '../../legos/Overlay';
import ErrorBoundary from '../../../../ErrorBoundary';
import DeviationDumbView from '../../../Dumbo';
import Timestamp from '../../../../Timestamp';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import s from './StatusThumb.scss';
var StatusThumb = function (_a) {
    var _b;
    var className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width, extraActions = _a.extraActions;
    var _c = useOverlayContext(deviation), showOverlay = _c.showOverlay, __forceHoveredForStories = _c.__forceHoveredForStories;
    var canShowTimeStamp = width && width > 150 && height && height > 150;
    return (React.createElement(HoverableWrapper, { className: classnames(s['root'], className), style: __assign({ width: width, height: height }, style), __forceHoveredForStories: __forceHoveredForStories },
        React.createElement(ErrorBoundary, { debugComponent: "StatusThumb" },
            React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height, responsive: responsive }),
            canShowTimeStamp && (React.createElement(HoverOnly, { reverseHidden: true, className: s['status-date'] },
                React.createElement(Timestamp, { timestamp: deviation.publishedTime || ((_b = deviation.status) === null || _b === void 0 ? void 0 : _b.ts) }))),
            React.createElement(DeviationLink, { deviation: deviation, className: s['link-overlay'], title: deviation.title },
                React.createElement("span", null)),
            showOverlay && (React.createElement(Overlay, { deviation: deviation, width: width, height: height, className: s['overlay'], extraActions: extraActions })))));
};
StatusThumb.displayName = 'StatusThumb';
export default StatusThumb;
//# sourceMappingURL=StatusThumb.js.map